import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: () => import('@/layout/index.vue'),
    redirect: '/dashboard',
    children: [
      { path: 'dashboard', name: 'Dashboard', component: () => import('@/views/dashboard/index.vue'), meta: { title: '数据概览' } },
      { path: 'role', name: 'Role', component: () => import('@/views/role/index.vue'), meta: { title: '角色管理' } },
      { path: 'user', name: 'User', component: () => import('@/views/user/index.vue'), meta: { title: '后台账号管理' } },
      { path: 'menu', name: 'Menu', component: () => import('@/views/menu/index.vue'), meta: { title: '菜单管理' } },
      { path: 'dict', name: 'Dict', component: () => import('@/views/dict/index.vue'), meta: { title: '字典表管理' } },
      { path: 'words', name: 'Words', component: () => import('@/views/words/index.vue'), meta: { title: '词典管理' } },
      { path: 'appuser', name: 'AppUser', component: () => import('@/views/appuser/index.vue'), meta: { title: '用户管理' } },
      { path: 'clinic-audit', name: 'ClinicAudit', component: () => import('@/views/appuser/clinic-audit.vue'), meta: { title: '诊所信息审核' } },
      { path: 'clinic-detail', name: 'ClinicDetail', component: () => import('@/views/appuser/clinic-detail.vue'), meta: { title: '诊所详情' } },
      { path: 'store-audit', name: 'StoreAudit', component: () => import('@/views/appuser/store-audit.vue'), meta: { title: '门店信息审核' } },
      { path: 'store-detail', name: 'StoreDetail', component: () => import('@/views/appuser/store-detail.vue'), meta: { title: '门店详情' } },
      { path: 'practice', name: 'Practice', component: () => import('@/views/practice/index.vue'), meta: { title: '练习记录' } },
      { path: 'wordmanage', name: 'WordManage', component: () => import('@/views/wordmanage/index.vue'), meta: { title: '英语单词管理' } },
      { path: 'product/list', name: 'ProductList', component: () => import('@/views/product/index.vue'), meta: { title: '项目管理' } },
      { path: 'product/edit', name: 'ProductEdit', component: () => import('@/views/product/edit.vue'), meta: { title: '编辑项目' } },
      { path: 'product/category', name: 'CategoryManage', component: () => import('@/views/product/category.vue'), meta: { title: '分类管理' } },
      { path: 'appuser/clinic-edit', name: 'ClinicEdit', component: () => import('@/views/appuser/clinic-edit.vue'), meta: { title: '编辑诊所信息' } },
      { path: 'order/list', name: 'OrderList', component: () => import('@/views/order/index.vue'), meta: { title: '订单管理' } },
      { path: 'order/detail', name: 'OrderDetail', component: () => import('@/views/order/detail.vue'), meta: { title: '订单详情' } },
      { path: 'purchase/list', name: 'PurchaseList', component: () => import('@/views/purchase/index.vue'), meta: { title: '采购单管理' } },
      { path: 'purchase/detail', name: 'PurchaseDetail', component: () => import('@/views/purchase/detail.vue'), meta: { title: '采购单详情' } },
      { path: 'theme/list', name: 'ThemeList', component: () => import('@/views/theme/index.vue'), meta: { title: '主题场管理' } },
      { path: 'theme/edit', name: 'ThemeEdit', component: () => import('@/views/theme/edit.vue'), meta: { title: '编辑主题场' } },
      { path: 'region-list', name: 'RegionList', component: () => import('@/views/region-list/index.vue'), meta: { title: '区域列表' } },
      { path: 'task-manage', name: 'TaskManage', component: () => import('@/views/task/index.vue'), meta: { title: '定时任务管理' } },
      { path: 'finance', name: 'Finance', component: () => import('@/views/finance/index.vue'), meta: { title: '财务管理' } },
      { path: 'change-password', name: 'ChangePassword', component: () => import('@/views/user/change-password.vue'), meta: { title: '修改密码' } }
    ]
  }
]

const router = new Router({ mode: 'hash', routes })

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('access_token')
  if (to.path === '/login') next()
  else token ? next() : next('/login')
})

export default router
